import { render, staticRenderFns } from "./pickListDetails.vue?vue&type=template&id=5210fb38&scoped=true"
import script from "./pickListDetails.vue?vue&type=script&lang=js"
export * from "./pickListDetails.vue?vue&type=script&lang=js"
import style0 from "./pickListDetails.vue?vue&type=style&index=0&id=5210fb38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210fb38",
  null
  
)

export default component.exports